export default {
  'controlledDisbursementsGrid.title': 'Account',
  'controlledDisbursementsGrid.amount': 'Amount',
  'controlledDisbursementsGrid.checkNumber': 'Check Number',
  'controlledDisbursementsGrid.date': 'Date',
  'controlledDisbursementsGrid.willBeAvailable': 'Detail data will be available after <%= time %>',
  'controlledDisbursementsGrid.firstPresentment': 'First Pres',
  'controlledDisbursementsGrid.firstPresentmentCount': 'Count',
  'controlledDisbursementsGrid.noDetailDataReporter': 'No detail data reported',
  'controlledDisbursementsGrid.notReported': 'Not Reported',
  'controlledDisbursementsGrid.presentment': 'Presentment',
  'controlledDisbursementsGrid.secondPresentment': 'Second Pres',
  'controlledDisbursementsGrid.secondPresentmentCount': 'Count',
  'controlledDisbursementsGrid.totals': 'Totals',
  'controlledDisbursementsGrid.totalsCount': 'Count',
  'controlledDisbursementsGrid.customCsvPrefix': 'Controlled Disbursement Grid'
};
